import {
    Box,
    Grid,
} from "@chakra-ui/react";

import ForgotPasswordForm from "./components/ForgotPasswordForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const ForgotPassword = () => {
    return (
        <Box
            minH="100vh"
            h={{
                base: "auto",
                lg: "100vh",
            }}
            bg="#F8FAFC"
            overflowY={{
                base: "auto",
                lg: "hidden",
            }}
        >
            <Box
                w="100%"
                h={{
                    base: "auto",
                    lg: "100%",
                }}
                bg="white"
            >
                <Grid
                    h={{
                        base: "auto",
                        lg: "100%",
                    }}
                    minH={{
                        base: "100vh",
                        lg: "100%",
                    }}
                    templateColumns={{
                        base: "1fr",
                        lg: "1fr 1fr",
                    }}
                >
                    <ForgotPasswordForm />
                    <LoginShowcase />
                </Grid>
            </Box>
        </Box>
    );
};

export default ForgotPassword;